<!-- 双列事件提示 -->
<template>
    <div class="DoubleEventHint">
        <div class="DoubleHintStart" :class="{'DoubleHintEnd': IsExpand}" @click="OpenDoubleHint(true)" v-if="IsShow">
          <div class="DoubleHintTop">
            <div class="HintNumber"><span>{{this.HintNumber}}</span></div>
            <div class="HintTitle">{{$t('lang.ScheduleConflict')}}</div>
            <div class="point" v-if="!IsExpand">...</div>
            <i class="iconfont el-icon-arrow-up" v-else @click.stop="OpenDoubleHint(false)"></i>
          </div>
          <div class="DoubleTimeList" v-if="IsExpand">
            <div class="DoubleTime" :class="{'SeleteDouble': item.eventId == eventId}" v-for="(item, index) in DoubleHintList" :key="index" @click="jumpDesignatedEvent(item)">
              {{TimeListTransition(item)}}
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      // 是否显示
      IsShow: false,
      // 是否展开
      IsExpand: false,
      // 提示列表
      DoubleHintList: [],
      // 提示数量
      HintNumber: 0,
      // 选中的
      eventId: ''
    }
  },
  computed: {
    ...mapState({
      State: (state) => state
    })
  },
  watch: {
    // 行为同步
    'State.BehaviorChange' (data) {
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'EventListChange' || data.action == 'getDoubleHint') {
        if (this.IsShow) {
          this.getDoubleHint()
        }
      } else if (data.action == 'doubleColumnEventsTime') {
        this.DoubleHintList = data.params
        this.HintNumber = this.DoubleHintList.length
        if (this.HintNumber > 0) {
          this.IsShow = true
        } else {
          this.IsShow = false
        }
      }
    }
  },
  created () {

  },
  mounted () {
    this.getDoubleHint()
  },
  methods: {
    // 获取提示
    getDoubleHint () {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) {
        this.IsShow = false
        return
      }
      const params = {
        programId
      }
      this.axios.post(Outil.getUrl('/event/checkDoubleColumn'), params)
        .then((res) => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            this.DoubleHintList = res.data.result
            this.HintNumber = this.DoubleHintList.length
            if (this.HintNumber > 0) {
              this.IsShow = true
            } else {
              this.IsShow = false
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    // 打开提示
    OpenDoubleHint (value) {
      this.IsExpand = value
    },
    // 时间显示转换
    TimeListTransition (item) {
      const startTime = this.TransitionCurrentTime(new Date(item.startTime))
      const endTime = this.TransitionCurrentTime(new Date(item.endTime))
      return `${startTime}  -  ${endTime}`
    },
    // 跳转到指定事件
    jumpDesignatedEvent (item) {
      const startTime = new Date(item.startTime)
      const Day = this.TransitionCurrentTime(startTime)
      const beforeDay = new Date(new Date(Day.split(' ')[0]).getTime() - 60 * 60 * 1000)
      const data = {
        Day: Day,
        beforeDay: this.TransitionCurrentTime(beforeDay),
        hours: startTime.getHours(),
        id: item.eventId
      }
      // this.eventId = item.eventId
      Bus.$emit('jumpDesignatedEvent', data)
    },
    TransitionCurrentTime (time) {
      let type = ''
      const y = time.getFullYear()
      let hour = time.getHours()
      let min = time.getMinutes()
      let s = time.getSeconds()
      const TimeFormat = Outil.getDateTimeFormat()
      if (TimeFormat.broadcastTimeFormat) {
        hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
      } else {
        if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
      }
      min = min >= 0 && min < 10 ? `0${min}` : min
      s = s >= 0 && s < 10 ? `0${s}` : s
      let mon
      if (time.getMonth() + 1 >= 10) {
        mon = time.getMonth() + 1
      } else {
        mon = `0${time.getMonth() + 1}`
      }
      let d
      if (time.getDate() >= 10) {
        d = time.getDate()
      } else {
        d = `0${time.getDate()}`
      }
      return `${y}/${mon}/${d} ${hour}:${min}:${s} ${type}`
    }
  }
}
</script>

<style scoped lang="less">
.DoubleEventHint {
  position: absolute;
  left: 50%;
  top: 20px;
  margin-left: -80px;
  .DoubleHintStart{
    width: 160px;
    min-height: 26px;
    background: #E56464;
    border-radius: 12px;
    padding: 0px 15px 0px 0px;
    .DoubleHintTop {
      display: flex;
      height: 26px;
      align-items: center;
      color: #000000;
      cursor: pointer;
      .HintNumber {
        overflow: hidden;
        span{
          display: block;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #FFFFFF;
          font-size: 20px;
          line-height: 30px;
          text-align: center;
          transform: scale(0.5);
          color: #FF9A24;
          font-weight: 700;
        }
      }
    }
  }
  .DoubleHintEnd{
    width: 360px;
    max-height: 150px;
    .DoubleHintTop{
      .el-icon-arrow-up{
        position: absolute;
        right: 10px;
        top: 5px;
        color: #FFFFFF;
        font-size: 16px;
      }
    }
    .DoubleTimeList{
      margin-top: 4px;
      padding-left: 25px;
      padding-bottom: 5px;
      max-height: 100px;
      overflow: auto;
      .DoubleTime{
        color: #FFFFFF;
        line-height: 1;
        border-bottom: 1px solid #FFFFFF;
        margin-bottom: 6px;
        text-align: left;
        cursor: pointer;
      }
      .SeleteDouble {
        color: #FFB523;
        border-bottom: 1px solid #FFB523;
      }
    }
    .DoubleTimeList::-webkit-scrollbar {
      width: 3px;
    }
    .DoubleTimeList::-webkit-scrollbar-thumb {
      background-color: #FFFFFF;
    }
  }
}
</style>
